import { createContext } from "react"

import { FlattenedTableItemType } from "./types"

export const defaultItemsContext: FlattenedTableItemType[] = []

export const ItemsContext = createContext(defaultItemsContext)
